export default __webpack_public_path__ + "static/media/etw_icon.4bd996d4.svg";